// register component(s) with react habitat

import IconsSlider from './IconsSlider'

export default {
  IconsSlider,
}
